import React from 'react'
import { useGeoState } from '../GeoProvider'
import moment from 'moment'
import styles from './DisplayDateAllergies.module.scss'

export const DisplayDateAllergies = ({
  location_name,
}) => {
  const {  displayDate } = useGeoState()
  return (
    <div className={styles.base}>
      <div className={styles.dateWeek}>
      <p className={styles.displayDateMargin}>
        
          {location_name} Cases: {' '} Week Ending {moment(displayDate).format('MMMM D, YYYY')}{' '}
        </p>
      </div>
    </div>
  )
}

export default DisplayDateAllergies
